export class UserHealthModel {
    public status: number;
    public emailConfirmed: boolean;
    public phoneNumberConfirmed: boolean;
}
